import { combineReducers } from "redux";
import billReducers from "./billReducers";

export default combineReducers({
  bill: billReducers
});




// WEBPACK FOOTER //
// ./src/reducers/index.js